document.addEventListener("DOMContentLoaded", () => {

  const breadcrumb = document.querySelector('.breadcrumbs');
  const currentUrl = window.location.pathname;
  const isProductPage = currentUrl.includes('/products/');
  const isCollectionPage = currentUrl.includes('/collections/');
  const isSearchPage = currentUrl.includes('/search');

  if (!breadcrumb) {
    return;
  }

    if (isSearchPage) {
    breadcrumb.style.visibility = 'hidden';
  }

  // ─── PRODUCT PAGE ──────────────────────────────────────────────
  if (isProductPage) {
    const metaBreadcrumbEl = document.querySelector('script[data-breadcrumb-meta]');
    const productDataEl = document.querySelector('script[data-breadcrumb-product]');

    let productData = null;
    if (productDataEl) {
      try { productData = JSON.parse(productDataEl.textContent); } catch (e) { }
    }

    if (metaBreadcrumbEl) {
      try {
        const metaItems = JSON.parse(metaBreadcrumbEl.textContent);
        if (Array.isArray(metaItems) && metaItems.length > 0) {
          const productTitle = productData?.title
            || document.querySelector('h1.product__title, h1[class*="product"], .product-single__title, h1')?.textContent?.trim()
            || document.title;
          const breadcrumbs = [{ name: "Home", url: "/" }];
          metaItems.forEach(item => {
            if (item['Collection Name'] && item['Collection Url']) {
              breadcrumbs.push({ name: item['Collection Name'], url: item['Collection Url'] });
            }
          });
          breadcrumbs.push({ name: productTitle, url: currentUrl });
          renderBreadcrumb(breadcrumb, breadcrumbs);
          return;
        }
      } catch (e) {
        console.warn('Breadcrumb metafield parse error:', e);
      }
    }

    injectSchemaFromExistingBreadcrumb(breadcrumb);
    return;
  }

  // ─── COLLECTION PAGE ──────────────────────────────────────────
  if (isCollectionPage) {

    const collectionDataEl = breadcrumb.querySelector('script[data-breadcrumb-collection]');
    let collectionData = null;
    if (collectionDataEl) {
      try { collectionData = JSON.parse(collectionDataEl.textContent); } catch (e) { }
    }

    if (collectionData && Array.isArray(collectionData.breadcrumb) && collectionData.breadcrumb.length > 0) {
      const breadcrumbs = [{ name: "Home", url: "/" }];
      collectionData.breadcrumb.forEach(item => {
        if (item['Collection Name'] && item['Collection Url']) {
          breadcrumbs.push({ name: item['Collection Name'], url: item['Collection Url'] });
        }
      });
      if (collectionData.current_tags && collectionData.current_tags.length > 0) {
        breadcrumbs.push({ name: collectionData.title, url: collectionData.url });
        breadcrumbs.push({ name: collectionData.current_tags.join(' + '), url: collectionData.url + '/' + collectionData.current_tags.join('+') });
      } else {
        breadcrumbs.push({ name: collectionData.title, url: collectionData.url });
      }
      renderBreadcrumb(breadcrumb, breadcrumbs);
      return;
    }

    const headerNavData = findActiveLinkInHeaderMenu(currentUrl);
    if (headerNavData && headerNavData.length > 0) {
      const breadcrumbs = [{ name: "Home", url: "/" }];
      headerNavData.forEach(item => breadcrumbs.push(item));
      if (collectionData && collectionData.current_tags && collectionData.current_tags.length > 0) {
        const tagUrl = collectionData.url + '/' + collectionData.current_tags.join('+');
        breadcrumbs.push({ name: collectionData.current_tags.join(' + '), url: tagUrl });
      }
      renderBreadcrumb(breadcrumb, breadcrumbs);
      return;
    }

    injectSchemaFromExistingBreadcrumb(breadcrumb);
    return;
  }

  // ─── SEARCH PAGE ──────────────────────────────────────────────
  if (isSearchPage) {
    const searchQuery = new URLSearchParams(window.location.search).get('q') || '';

    const renderSearchBreadcrumb = () => {
      const countEl = document.querySelector('.boost-sd__product-count');
      const countText = countEl?.textContent?.trim() || '';
      const match = countText.match(/[\d,]+/);
      const count = match ? match[0] : null;

      const label = count !== null
        ? `Search: ${count} results found for "${searchQuery}"`
        : `Search results for "${searchQuery}"`;

      renderBreadcrumb(breadcrumb, [
        { name: 'Home', url: '/' },
        { name: label, url: currentUrl + window.location.search }
      ]);
    };

    // If Boost already rendered the count, use it immediately
    if (document.querySelector('.boost-sd__product-count')) {
      renderSearchBreadcrumb();
      return;
    }

    // Otherwise observe the DOM until it appears
    const searchObserver = new MutationObserver(() => {
      if (document.querySelector('.boost-sd__product-count')) {
        searchObserver.disconnect();
        renderSearchBreadcrumb();
      }
    });

    searchObserver.observe(document.body, { childList: true, subtree: true });

    // Fallback: stop waiting after 5s and render without count
    setTimeout(() => {
      searchObserver.disconnect();
      renderSearchBreadcrumb();
    }, 5000);

    return;
  }

  // ─── DEFAULT ──────────────────────────────────────────────────
  if (currentUrl.startsWith('/pages/')) {
    const activeNavData = findActiveLinkInMenu(currentUrl);
    if (activeNavData && activeNavData.length > 0) {
      const lastTrailItem = activeNavData[activeNavData.length - 1];
      const breadcrumbs = [{ name: "Home", url: "/" }];
      activeNavData.forEach(item => breadcrumbs.push(item));
      if (lastTrailItem.url !== currentUrl) {
        const pageTitle = breadcrumb.querySelector('.breadcrumbs__item[aria-current="page"] span')?.textContent.trim()
          || document.title;
        breadcrumbs.push({ name: pageTitle, url: currentUrl });
      }
      renderBreadcrumb(breadcrumb, breadcrumbs);
      return;
    }
  }

  injectSchemaFromExistingBreadcrumb(breadcrumb);

});


// ─── READ EXISTING HTML BREADCRUMB → INJECT JSON-LD ──────────────
function injectSchemaFromExistingBreadcrumb(breadcrumbEl) {
  const items = breadcrumbEl.querySelectorAll('.breadcrumbs__item');
  if (!items || items.length === 0) return;

  const breadcrumbs = [];

  items.forEach(item => {
    const link = item.querySelector('a.breadcrumbs__link');
    const span = item.querySelector('span');

    if (link) {
      breadcrumbs.push({
        name: link.textContent.trim(),
        url: link.getAttribute('href')
      });
    } else if (span) {
      breadcrumbs.push({
        name: span.textContent.trim(),
        url: window.location.pathname + window.location.search
      });
    }
  });

  if (breadcrumbs.length === 0) return;

  breadcrumbEl.classList.remove('breadcrumbs--loading');

  const schemaJson = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": window.location.origin + toSafePath(item.url)
    }))
  };

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(schemaJson, null, 2);
  document.head.appendChild(script);
}


// ─── FIND ACTIVE LINK IN MEGA MENU ──────────────────────────────
function findActiveLinkInMenu(currentUrl) {
  const trail = [];

  const allLinks = document.querySelectorAll(
    '.mega-menu-3l__sidebar-link, .mega-menu-3l__child-link, .mega-menu__link, .mega-menu-4col__link'
  );

  let activeLink = null;

  allLinks.forEach(link => {
    const href = link.getAttribute('href');
    if (href && href !== '/' && currentUrl === href && !activeLink) {
      activeLink = link;
    }
  });

  if (!activeLink) {
    let longestMatch = '';
    allLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (
        href &&
        href !== '/' &&
        href !== '/collections' &&
        currentUrl.startsWith(href) &&
        href.length > longestMatch.length
      ) {
        longestMatch = href;
        activeLink = link;
      }
    });
  }

  if (!activeLink) {
    const viewAllLinks = document.querySelectorAll(
      '.mega-menu-3l__sidebar-view-all, .mega-menu-3l__view-all-top'
    );
    viewAllLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (href && href !== '/' && currentUrl === href && !activeLink) {
        activeLink = link;
      }
    });
  }

  if (!activeLink) return trail;

  const megaMenu3l = activeLink.closest('.mega-menu-3l');

  if (megaMenu3l) {
    const hasPanel = !!megaMenu3l.querySelector('.mega-menu-3l__panels');

    const submenuInner = megaMenu3l.closest('.menu-list__submenu-inner');
    const submenuDiv = submenuInner?.closest('.menu-list__submenu');
    const listItem = submenuDiv?.closest('.menu-list__list-item');
    const topLevelLink = listItem?.querySelector(':scope > a.menu-list__link');

    if (topLevelLink) {
      const topName = topLevelLink.querySelector('.menu-list__link-title')?.textContent.trim()
        || topLevelLink.textContent.trim();
      const topUrl = topLevelLink.getAttribute('href');
      if (topUrl && topUrl !== currentUrl) {
        trail.push({ name: topName, url: topUrl });
      }
    } else if (megaMenu3l.classList.contains('mega-menu-4col')) {
      const l1Title = megaMenu3l.getAttribute('data-l1-title');
      const viewAllLink = megaMenu3l.querySelector('.mega-menu-4col__view-all');
      if (l1Title && viewAllLink) {
        const viewAllUrl = viewAllLink.getAttribute('href');
        if (viewAllUrl && viewAllUrl !== currentUrl) {
          trail.push({ name: l1Title, url: viewAllUrl });
        }
      }
    }

    if (hasPanel) {
      const panel = activeLink.closest('.mega-menu-3l__panel');

      if (panel) {
        const panelId = panel.getAttribute('id');
        const sidebarItem = megaMenu3l.querySelector(`[data-panel-target="${panelId}"]`);

        if (sidebarItem) {
          const sidebarLink = sidebarItem.querySelector('.mega-menu-3l__sidebar-link');
          if (sidebarLink) {
            const sidebarUrl = sidebarLink.getAttribute('href');
            const sidebarName = sidebarLink.querySelector('.wrap-text')?.textContent.trim()
              || sidebarLink.textContent.trim();
            if (sidebarUrl && sidebarUrl !== currentUrl) {
              trail.push({ name: cleanName(sidebarName), url: sidebarUrl });
            }
          }
        }

        trail.push({
          name: cleanName(
            activeLink.querySelector('.wrap-text')?.textContent.trim()
            || activeLink.textContent.trim()
          ),
          url: activeLink.getAttribute('href')
        });

      } else if (activeLink.classList.contains('mega-menu-3l__sidebar-link')) {
        trail.push({
          name: cleanName(
            activeLink.querySelector('.wrap-text')?.textContent.trim()
            || activeLink.textContent.trim()
          ),
          url: activeLink.getAttribute('href')
        });

      } else {
        trail.push({
          name: cleanName(activeLink.textContent.trim()),
          url: activeLink.getAttribute('href')
        });
      }

    } else {
      trail.push({
        name: cleanName(
          activeLink.querySelector('.wrap-text')?.textContent.trim()
          || activeLink.textContent.trim()
        ),
        url: activeLink.getAttribute('href')
      });
    }

  } else {
    trail.push({
      name: cleanName(
        activeLink.querySelector('.menu-list__link-title')?.textContent.trim()
        || activeLink.textContent.trim()
      ),
      url: activeLink.getAttribute('href')
    });
  }

  return trail;
}


// ─── FIND ACTIVE LINK IN HEADER MENU ────────────────────────────
function findActiveLinkInHeaderMenu(currentUrl) {
  const trail = [];
  const headerMenuInner = document.querySelector('.header-menu__inner');
  if (!headerMenuInner) return trail;

  const navSelectors = [
    '.menu-list__link',
    '.mega-menu-3l__sidebar-link',
    '.mega-menu-3l__sidebar-view-all',
    '.mega-menu-3l__view-all-top',
    '.mega-menu-3l__child-link',
    '.mega-menu__link',
    '.mega-menu-4col__link'
  ].join(', ');

  const allLinks = headerMenuInner.querySelectorAll(navSelectors);
  let activeLink = null;

  allLinks.forEach(link => {
    const href = link.getAttribute('href');
    if (href && href !== '/' && currentUrl === href && !activeLink) {
      activeLink = link;
    }
  });

  if (!activeLink) {
    let longestMatch = '';
    allLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (
        href &&
        href !== '/' &&
        href !== '/collections' &&
        currentUrl.startsWith(href) &&
        href.length > longestMatch.length
      ) {
        longestMatch = href;
        activeLink = link;
      }
    });
  }

  if (!activeLink) return trail;

  const submenuInner = activeLink.closest('.menu-list__submenu-inner');

  if (submenuInner) {
    const listItem = submenuInner.closest('.menu-list__list-item');
    const parentLink = listItem?.querySelector(':scope > a.menu-list__link');
    if (parentLink) {
      const parentHref = parentLink.getAttribute('href');
      const parentName = parentLink.querySelector('.menu-list__link-title')?.textContent.trim()
        || parentLink.textContent.trim();
      if (parentHref && parentHref !== currentUrl) {
        trail.push({ name: cleanName(parentName), url: parentHref });
      }
    }

    if (activeLink.classList.contains('mega-menu-3l__child-link') ||
        activeLink.classList.contains('mega-menu__link')) {
      const panel = activeLink.closest('.mega-menu-3l__panel');
      if (panel) {
        const megaMenu3l = panel.closest('.mega-menu-3l');
        const sidebarItem = megaMenu3l?.querySelector(`[data-panel-target="${panel.id}"]`);
        const sidebarLink = sidebarItem?.querySelector('.mega-menu-3l__sidebar-link');
        if (sidebarLink) {
          const sidebarUrl = sidebarLink.getAttribute('href');
          const sidebarName = sidebarLink.querySelector('.wrap-text')?.textContent.trim()
            || sidebarLink.textContent.trim();
          if (sidebarUrl && sidebarUrl !== currentUrl) {
            trail.push({ name: cleanName(sidebarName), url: sidebarUrl });
          }
        }
      }
    }
  }

  const activeName = activeLink.querySelector('.menu-list__link-title, .wrap-text')?.textContent.trim()
    || activeLink.textContent.trim();
  trail.push({ name: cleanName(activeName), url: activeLink.getAttribute('href') });

  return trail;
}


// ─── CLEAN NAME ──────────────────────────────────────────────────
function cleanName(name) {
  return name.replace(/^View\s+All\s+/i, '').trim();
}


// ─── SAFE URL ────────────────────────────────────────────────────
// Names and URLs can come from the query string, URL path (tags) or metafields,
// so only same-origin paths are accepted and everything is set as text, never HTML.
function toSafePath(url) {
  try {
    const parsed = new URL(String(url || ''), window.location.origin);
    if (parsed.origin !== window.location.origin) return '/';
    return parsed.pathname + parsed.search;
  } catch (e) {
    return '/';
  }
}


// ─── RENDER BREADCRUMB + JSON-LD ────────────────────────────────
function renderBreadcrumb(breadcrumbEl, breadcrumbs) {

  const list = document.createElement('ol');
  list.className = 'breadcrumbs__list';

  const safeItems = breadcrumbs.map(item => ({ name: String(item.name || ''), url: toSafePath(item.url) }));

  safeItems.forEach((item, index) => {
    const isLast = index === safeItems.length - 1;
    const li = document.createElement('li');
    li.className = 'breadcrumbs__item';

    if (!isLast) {
      const link = document.createElement('a');
      link.className = 'breadcrumbs__link';
      link.href = item.url;
      link.textContent = item.name;
      li.appendChild(link);
    } else {
      li.setAttribute('aria-current', 'page');
      const span = document.createElement('span');
      span.textContent = item.name;
      li.appendChild(span);
    }

    list.appendChild(li);
  });

  const schemaJson = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": safeItems.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": window.location.origin + item.url
    }))
  };

  const schema = document.createElement('script');
  schema.type = 'application/ld+json';
  schema.textContent = JSON.stringify(schemaJson);

  breadcrumbEl.replaceChildren(list, schema);

  breadcrumbEl.classList.remove('breadcrumbs--loading');
  breadcrumbEl.style.display = 'grid';
  breadcrumbEl.style.visibility = 'visible';
}